import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px;
  justify-content: center;
  width: 100%;
  position: fixed;
  height: 100%;
  z-index: 10;

  @media (max-width: 1024px) {
    padding: 2rem;
  }
`;

export const Content = styled.div`
  float: left;
  width: 32rem;

  input {
    border-radius: 0px !important;
    padding: 0px !important;
    border: none !important;
    border-bottom: 2px solid rgba(255, 255, 255, 0.2) !important;
    color: #fff !important;

    ::-webkit-input-placeholder {
      color: #ccc !important;
    }
  }
  @media (max-width: 1024px) {
    width: 100%;
  }
`;

export const LogoClient = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  float: left;
  width: 100%;
  margin: 0 0 2rem 0;

  img {
    max-width: 16rem;
  }

  @media (max-width: 1024px) {
  }
`;

export const Information = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  padding: 0px;
  justify-content: center;
  margin: 2rem 0 0 0;
  float: left;

  h1 {
    margin: 0 0 0rem 0;
    padding: 0 20px;
    color: #fff;
    font-weight: 500;
    font-size: 1.6rem;
    text-align: center;
    width: 100%;
  }

  h2 {
    padding: 0 20px;
    color: #555;
    font-weight: 500;
    font-size: 0.6rem;
    text-align: center;
    width: 100%;
  }

  @media (max-width: 1024px) {
    max-width: 100%;

    h1 {
      font-size: 22px;
    }
    span {
      font-size: 16px;
    }
  }
`;

export const Logo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin: 0;
  float: left;

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0;
    float: left;

    img {
      float: left;
      width: 100%;
      max-width: 10rem;
    }
  }
`;

export const Preloader = styled.div`
  float: left;
  margin: 1.5rem 0 0 0;
  font-size: 2rem;
  font-weight: bold;
  color: #ccc;
  text-align: center;

  @media (max-width: 1024px) {
    font-size: 1.2rem;
  }
`;
